import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const todayFactors = async () => axios.get(Routes.TODAY_FACTORS);

export const useTodayFactors = () => {
  return useQuery({
    queryKey: [Keys.TODAY_FACTORS_QRY],
    queryFn: todayFactors,
    cacheTime: 0,
    enabled: false,
  });
};
